(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  // Header JS (search-related excerpt)
  // Responsibilities:
  // - Toggle mobile search overlay/panel with minimal transitions (fadeIn/fadeOut)
  // - Manage focus and aria-expanded on the toggle button
  // Dependencies:
  // - CSS uses Tailwind (tw-) classes; fade helpers add/remove opacity utilities
  // - Markup must contain .js-mobile-search-panel and input .js-mobile-search-input
  document.addEventListener('DOMContentLoaded', function() {
    // Shared feature detection
    const isIOS = (() => {
      try {
        const ua = navigator.userAgent || '';
        const platform = navigator.platform || '';
        return /iPad|iPhone|iPod/.test(ua) || (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      } catch (e) { return false; }
    })();

    // Elements: main menu
    const menuContainer = document.querySelector('.js-main-menu-container');
    const openButton = document.querySelector('.js-main-menu-open');
    const closeButton = document.querySelector('.js-main-menu-close');
    const overlay = document.querySelector('.js-main-menu-overlay');
    const mqlMinSm = window.matchMedia('(min-width: 640px)');

    // Elements: mobile search
    const mobileSearchToggleContainer = document.getElementById('js-mobile-search-container');
    const mobileSearchToggleButton = mobileSearchToggleContainer ? mobileSearchToggleContainer.querySelector('button') : null;
    const mobileSearchPanel = document.querySelector('.js-mobile-search-panel');
    const mobileSearchInput = mobileSearchPanel ? mobileSearchPanel.querySelector('.js-mobile-search-input') : null;
    const closeButtons = mobileSearchPanel ? mobileSearchPanel.querySelectorAll('.js-mobile-search-close') : [];
    const resultsContainer = mobileSearchPanel ? mobileSearchPanel.querySelector('[data-predictive-search]') : null;

    // Elements: desktop search
    const desktopSearchPanel = document.querySelector('.js-desktop-search-form');
    const desktopSearchInput = desktopSearchPanel ? desktopSearchPanel.querySelector('.js-header-search-input') : null;
    const desktopSearchResults = desktopSearchPanel ? desktopSearchPanel.querySelector('[data-predictive-search]') : null;

    // State
    let isMenuOpen = false;
    let menuKeydownHandler = null;
    let menuPreviouslyFocusedElement = null;

    let searchKeydownHandler = null;
    let searchPreviouslyFocusedElement = null;
    let touchStartY = 0;
    let touchStartX = 0;
    const HORIZONTAL_DOMINANCE_THRESHOLD = 2;
    let isDismissingKeyboard = false;
    // Scroll guard state (simple ref counter)
    let scrollGuardUseCount = 0;
    let activeGuardDetach = null;
    

    // ---------- Small utilities ----------
    const showElement = (el) => { if (!el) return; el.classList.remove('tw-hidden'); if(el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', 'false'); };
    const hideElement = (el) => { if (!el) return; el.classList.add('tw-hidden'); if(el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', 'true'); };

    const createTrapFocusHandler = (container, onEscape) => {
      const focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          if (typeof onEscape === 'function') onEscape();
          return;
        }
        if (e.key === 'Tab') {
          const focusables = Array.from(container.querySelectorAll(focusableSelectors)).filter(el => el.offsetParent !== null || el === document.activeElement);
          if (focusables.length === 0) return;
          const firstEl = focusables[0];
          const lastEl = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === firstEl) {
            e.preventDefault();
            lastEl.focus();
          } else if (!e.shiftKey && document.activeElement === lastEl) {
            e.preventDefault();
            firstEl.focus();
          }
        }
      };
    };

    // Get maximum transition time (delay + duration) in ms for an element
    const getTransitionMs = (el, propFilter) => {
      try {
        const styles = window.getComputedStyle(el);
        const parseTime = (t) => {
          if (t.endsWith('ms')) return parseFloat(t);
          if (t.endsWith('s')) return parseFloat(t) * 1000;
          const n = parseFloat(t);
          return Number.isFinite(n) ? n : 0;
        };
        const durations = (styles.transitionDuration || '0s').split(',').map(s => s.trim()).map(parseTime);
        const delays = (styles.transitionDelay || '0s').split(',').map(s => s.trim()).map(parseTime);
        const properties = (styles.transitionProperty || '').split(',').map(s => s.trim());
        const count = Math.max(durations.length, delays.length);
        let maxMs = 0;
        for (let i = 0; i < count; i++) {
          const dur = durations[i % durations.length] || 0;
          const del = delays[i % delays.length] || 0;
          const prop = properties[i % properties.length] || 'all';
          if (!propFilter || prop === propFilter || prop === 'all') {
            maxMs = Math.max(maxMs, dur + del);
          }
        }
        return Math.round(maxMs);
      } catch (e) {
        return 0;
      }
    };

    const fadeIn = (el) => {
      if (!el) return;
      showElement(el);
      el.classList.add('tw-opacity-0');
      el.offsetWidth;
      requestAnimationFrame(() => {
        el.classList.remove('tw-opacity-0');
        el.classList.add('tw-opacity-100');
      });
    };

    const fadeOut = (el, onEnd) => {
      if (!el) { if (typeof onEnd === 'function') onEnd(); return; }
      const done = () => { hideElement(el); if (typeof onEnd === 'function') onEnd(); };
      const fallbackMs = Math.max(180, (getTransitionMs(el, 'opacity') || 0) + 60);
      const handler = (event) => { if (event.propertyName === 'opacity') done(); };
      el.addEventListener('transitionend', handler, { once: true });
      el.classList.remove('tw-opacity-100');
      el.classList.add('tw-opacity-0');
      setTimeout(done, fallbackMs);
    };

    // Dismiss iOS keyboard when scrolling results with a smooth transition (Tailwind classes)
    const dismissKeyboardOnScroll = () => {
      if (!mobileSearchInput) return;
      if (document.activeElement === mobileSearchInput && !isDismissingKeyboard) {
        isDismissingKeyboard = true;
        if (mobileSearchPanel) mobileSearchPanel.classList.add('tw-transform', 'tw-transition-all', 'tw-duration-300', 'tw-ease-out', 'tw-translate-y-0');
        requestAnimationFrame(() => {
          if (mobileSearchPanel) mobileSearchPanel.classList.add('tw-translate-y-1', 'tw-opacity-90');
          mobileSearchInput.blur();
          setTimeout(() => {
            if (mobileSearchPanel) mobileSearchPanel.classList.remove('tw-translate-y-1', 'tw-opacity-90', 'tw-transform', 'tw-transition-all', 'tw-duration-300', 'tw-ease-out');
            isDismissingKeyboard = false;
          }, 350);
        });
      }
    };

    if (resultsContainer) {
      ['touchmove', 'scroll', 'wheel'].forEach((evt) => {
        resultsContainer.addEventListener(evt, dismissKeyboardOnScroll, { passive: true });
      });
    }

    // Overlay helpers (menu overlay)
    const showOverlay = () => {
      if (!overlay) return;
      overlay.classList.add('tw-fixed', 'tw-inset-0', 'tw-bg-black', 'tw-bg-opacity-40', 'tw-z-40', 'tw-transition', 'tw-duration-300', 'tw-ease-in-out');
      fadeIn(overlay);
    };
    const hideOverlay = () => {
      if (!overlay || overlay.classList.contains('tw-hidden')) return;
      fadeOut(overlay);
    };

    // Guarded scroll (menu only; search simplified)
    const getScrollableParent = (element) => {
      let el = element;
      while (el && el !== document.body && el !== document.documentElement) {
        try {
          const style = window.getComputedStyle(el);
          const canScrollY = /(auto|scroll)/.test(style.overflowY || '') || /(auto|scroll)/.test(style.overflow || '');
          if (canScrollY && el.scrollHeight > el.clientHeight) return el;
        } catch (e) {}
        el = el.parentElement;
      }
      return null;
    };

    // Find nearest scrollable parent for a given axis ("x" or "y")
    const getScrollableParentAxis = (element, axis) => {
      let el = element;
      const isHorizontal = axis === 'x';
      while (el && el !== document.body && el !== document.documentElement) {
        try {
          const style = window.getComputedStyle(el);
          const overflowAxis = isHorizontal ? (style.overflowX || style.overflow) : (style.overflowY || style.overflow);
          const canScroll = /(auto|scroll)/.test(overflowAxis || '');
          if (canScroll) {
            if (isHorizontal && el.scrollWidth > el.clientWidth) return el;
            if (!isHorizontal && el.scrollHeight > el.clientHeight) return el;
          }
        } catch (e) {}
        el = el.parentElement;
      }
      return null;
    };

    const withinGuardedOverlay = (target) => {
      try {
        const inMobileSearch = mobileSearchPanel ? mobileSearchPanel.contains(target) : false;
        const inMenu = menuContainer ? menuContainer.contains(target) : false;
        return inMobileSearch || inMenu;
      } catch (e) { return false; }
    };

    const attachScrollGuards = () => {
      if (!isIOS) return () => {};
      const onTouchStart = (e) => {
        if (!withinGuardedOverlay(e.target)) return;
        try {
          if (e.touches && e.touches.length) {
            touchStartY = e.touches[0].clientY;
            touchStartX = e.touches[0].clientX;
          }
        } catch (err) {}
      };
      const onTouchMove = (e) => {
        const target = e.target;
        if (!withinGuardedOverlay(target)) { e.preventDefault(); return false; }
        const scroller = getScrollableParentAxis(target, 'y') || menuContainer;
        const currentY = (e.touches && e.touches.length) ? e.touches[0].clientY : touchStartY;
        const currentX = (e.touches && e.touches.length) ? e.touches[0].clientX : touchStartX;
        const deltaY = currentY - touchStartY;
        const deltaX = currentX - touchStartX;

        // Allow horizontal panning within whitelisted containers (e.g. featured links)
        const isHorizontalDominant = Math.abs(deltaX) > Math.abs(deltaY) + HORIZONTAL_DOMINANCE_THRESHOLD;
        if (isHorizontalDominant) {
          const xScroller = getScrollableParentAxis(target, 'x');
          const xContainer = target.closest ? target.closest('.js-allow-horizontal-pan') : null;
          const xEl = xScroller || xContainer;
          if (xEl && xEl.scrollWidth > xEl.clientWidth) {
            const atLeft = xEl.scrollLeft <= 0;
            const atRight = Math.ceil(xEl.scrollLeft + xEl.clientWidth) >= xEl.scrollWidth;
            const isPanningRight = deltaX > 0;
            const isPanningLeft = deltaX < 0;
            if ((atLeft && isPanningRight) || (atRight && isPanningLeft)) {
              e.preventDefault();
              return false;
            }
            // Let the browser handle horizontal scrolling
            return;
          }
          // If no horizontal scrollable element, fall through to vertical guard logic
        }
        const atTop = scroller.scrollTop <= 0;
        const atBottom = Math.ceil(scroller.scrollTop + scroller.clientHeight) >= scroller.scrollHeight;
        const isScrollingDown = deltaY > 0;
        const isScrollingUp = deltaY < 0;
        if ((atTop && isScrollingDown) || (atBottom && isScrollingUp) || scroller.scrollHeight <= scroller.clientHeight) {
          e.preventDefault();
          return false;
        }
      };
      const onWheel = (e) => {
        const target = e.target;
        if (!withinGuardedOverlay(target)) { e.preventDefault(); return false; }
        const scroller = getScrollableParentAxis(target, 'y') || menuContainer;
        const deltaY = e.deltaY || 0;
        const atTop = scroller.scrollTop <= 0;
        const atBottom = Math.ceil(scroller.scrollTop + scroller.clientHeight) >= scroller.scrollHeight;
        if ((atTop && deltaY < 0) || (atBottom && deltaY > 0) || scroller.scrollHeight <= scroller.clientHeight) {
          e.preventDefault();
          return false;
        }
      };
      document.addEventListener('touchstart', onTouchStart, { passive: false, capture: true });
      document.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });
      document.addEventListener('wheel', onWheel, { passive: false, capture: true });
      return () => {
        document.removeEventListener('touchstart', onTouchStart, { capture: true });
        document.removeEventListener('touchmove', onTouchMove, { capture: true });
        document.removeEventListener('wheel', onWheel, { capture: true });
      };
    };
    const attachGuardsFor = (_userKey) => {
      scrollGuardUseCount += 1;
      if (!activeGuardDetach) activeGuardDetach = attachScrollGuards();
    };
    const detachGuardsFor = (_userKey) => {
      scrollGuardUseCount = Math.max(0, scrollGuardUseCount - 1);
      if (scrollGuardUseCount === 0 && typeof activeGuardDetach === 'function') {
        try { activeGuardDetach(); } catch (e) {}
        activeGuardDetach = null;
      }
    };

    // ---------- Main menu ----------
    const openMenu = () => {
      if (!menuContainer) return;
      showElement(menuContainer);
      isMenuOpen = true;
      if (mqlMinSm && mqlMinSm.matches) showOverlay(); else hideOverlay();
      // Ensure scroll guards are active while menu is open (mobile Safari hardening)
      attachGuardsFor('menu');
      // Force reflow before transform change
      menuContainer.offsetWidth;
      requestAnimationFrame(() => { menuContainer.classList.remove('tw--translate-x-full'); });
      if (openButton) openButton.setAttribute('aria-expanded', 'true');
      menuPreviouslyFocusedElement = document.activeElement;
      const focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      const focusable = menuContainer.querySelectorAll(focusableSelectors);
      if (focusable.length) focusable[0].focus(); else menuContainer.focus();
      menuKeydownHandler = createTrapFocusHandler(menuContainer, () => closeMenu());
      document.addEventListener('keydown', menuKeydownHandler);
    };
    const closeMenu = () => {
      if (!menuContainer) return;
      menuContainer.classList.add('tw--translate-x-full');

      let cleaned = false;
      let fallbackTimer = null;

      const cleanup = () => {
        if (cleaned) return;
        cleaned = true;
        try { menuContainer.removeEventListener('transitionend', onTransitionEnd); } catch (e) {}
        if (fallbackTimer) { clearTimeout(fallbackTimer); fallbackTimer = null; }
        hideElement(menuContainer);
        hideOverlay();
        if (openButton) openButton.setAttribute('aria-expanded', 'false');
        if (menuKeydownHandler) { document.removeEventListener('keydown', menuKeydownHandler); menuKeydownHandler = null; }
        // Remove scroll guards if no other overlays need them
        detachGuardsFor('menu');
        if (menuPreviouslyFocusedElement && typeof menuPreviouslyFocusedElement.focus === 'function') {
          menuPreviouslyFocusedElement.focus();
          menuPreviouslyFocusedElement = null;
        } else if (openButton) {
          openButton.focus();
        }
        isMenuOpen = false;
      };

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'transform') return;
        cleanup();
      };

      // Listen for the transition end, but also set a reliable fallback
      menuContainer.addEventListener('transitionend', onTransitionEnd);
      const fallbackMs = Math.max(240, (getTransitionMs(menuContainer, 'transform') || 0) + 100);
      fallbackTimer = setTimeout(cleanup, fallbackMs);
    };
    if (openButton) openButton.addEventListener('click', openMenu);
    if (closeButton) closeButton.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', () => closeMenu());
    if (mqlMinSm && typeof mqlMinSm.addEventListener === 'function') {
      mqlMinSm.addEventListener('change', (e) => { if (!isMenuOpen) return; if (e.matches) showOverlay(); else hideOverlay(); });
    }

    // ---------- Mobile predictive search panel ----------
    const openPanel = () => {
      if (!mobileSearchPanel) return;
      // Fade in panel
      fadeIn(mobileSearchPanel);
      if (mobileSearchToggleButton && mobileSearchToggleButton.hasAttribute('aria-expanded')) mobileSearchToggleButton.setAttribute('aria-expanded', 'true');
      searchPreviouslyFocusedElement = document.activeElement;
      if (mobileSearchInput) mobileSearchInput.focus();
      try { if (resultsContainer) resultsContainer.scrollTop = 0; } catch (e) {}
      // Close on Escape
      searchKeydownHandler = (e) => { if (e.key === 'Escape') { e.preventDefault(); closePanel(); } };
      document.addEventListener('keydown', searchKeydownHandler);
    };
    const closePanel = () => {
      if (!mobileSearchPanel) return;
      // Fade out panel
      fadeOut(mobileSearchPanel);
      // Clear predictive results and reset input for a clean state
      try {
        const ps = mobileSearchPanel.querySelector('predictive-search');
        if (ps && typeof ps.close === 'function') ps.close(true);
      } catch (e) {}
      if (mobileSearchToggleButton && mobileSearchToggleButton.hasAttribute('aria-expanded')) mobileSearchToggleButton.setAttribute('aria-expanded', 'false');
      if (searchKeydownHandler) { document.removeEventListener('keydown', searchKeydownHandler); searchKeydownHandler = null; }
      if (searchPreviouslyFocusedElement && typeof searchPreviouslyFocusedElement.focus === 'function') {
        searchPreviouslyFocusedElement.focus();
        searchPreviouslyFocusedElement = null;
      }
    };
    if (mobileSearchToggleContainer && mobileSearchPanel && mobileSearchToggleButton) {
      mobileSearchToggleButton.addEventListener('click', function(event) {
        event.preventDefault();
        if (mobileSearchPanel.classList.contains('tw-hidden')) openPanel();
      });
    }
    if (mobileSearchPanel && closeButtons && closeButtons.forEach) {
      closeButtons.forEach((btn) => { btn.addEventListener('click', (e) => { e.preventDefault(); closePanel(); }); });
    }

    // ---------- Desktop predictive search panel ----------
    // Close predictive search when clicking outside the results container
    if (desktopSearchResults) {
      document.addEventListener('click', (e) => {
        if (!desktopSearchResults.contains(e.target)) {
          if (desktopSearchResults) desktopSearchResults.innerHTML = '';
          if (desktopSearchInput && desktopSearchInput.hasAttribute('aria-expanded')) desktopSearchInput.setAttribute('aria-expanded', false);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      const urls = this.dataset.urls.split(',');
      const fetchPromises = urls.map(url => fetch(url).then(response => response.text()));

      Promise.all(fetchPromises)
        .then(responses => {
          // Don't show repeated recommendations products
          const productIds = new Set();
          const recommendationsHtml = responses.map((response, index) => {

            const html = document.createElement('div');
            html.innerHTML = response;
            
            const recommendations = html.querySelectorAll('.recommended-product');

            return Array.from(recommendations).map(product => {
              const productId = product.dataset.productId; 

              if (!productIds.has(productId)) {
                productIds.add(productId);
                return product.outerHTML;
              }

              return '';
            }).join('');
          }).join('');

          if (recommendationsHtml.trim().length) {
            this.innerHTML = recommendationsHtml;
            
            // Re-initialize slide-up-cart event listeners for dynamically loaded content
            if (window.slideUpCart) {
              window.slideUpCart.interceptAddToCartForms();
            }
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);



  } catch(e) { console.error(e); }
})();
})();
